(() => {
  const BUILDERS = '[data-bizzymagic-card-builder]';
  const MAX_IMAGE_BYTES = 8 * 1024 * 1024;
  const ALLOWED_IMAGE_TYPES = ['image/jpeg', 'image/png', 'image/webp'];
  const PURCHASE_CONTRACT_VERSION = 'BM-PC-2.0';
  const PRINT_SPEC_VERSION = 'BM-PRINT-69x94-DUPLEX-v2';
  const PRINT_ASSET_SET_ID = 'BM-SABRINA-20260813-v1';
  const PRINT_BACK_ASSET_SHA256 = '7aa3b54455f785656b08b5a7134de3e7cce5d7b46ee5bd90d4bc874adda33767';
  const SCRIPT_URL = document.currentScript?.src || '';
  const storefrontAssetUrl = (filename) => {
    if (!SCRIPT_URL) return `/assets/${filename}`;
    return new URL(filename, SCRIPT_URL).href;
  };
  const COLOR_ORDER = ['W', 'U', 'B', 'R', 'G'];
  const MANA_ASSET_URLS = Object.fromEntries(COLOR_ORDER.map((token) => [
    token,
    storefrontAssetUrl(`bizzymagic-mana-${token.toLowerCase()}.png`),
  ]));

  const options = {
    subjectKind: ['person', 'artifact', 'team'],
    cardType: ['creature', 'instant', 'sorcery', 'artifact', 'enchantment', 'land'],
    role: ['creator', 'leader', 'strategist', 'executor', 'explorer', 'connector'],
    style: ['epic', 'realistic', 'tech', 'corporate', 'creative'],
    strength: ['creativity', 'determination', 'intelligence', 'empathy', 'leadership', 'precision'],
    approach: ['direct', 'strategic', 'patient', 'collaborative', 'instinctive'],
    level: ['growing', 'solid', 'advanced', 'expert', 'iconic'],
    motivation: ['improve', 'help', 'goals', 'create', 'experiences'],
  };

  const copy = {
    it: {
      eyebrow: 'Configuratore AI BizzyMagic', title: 'Crea una carta che parla davvero di te',
      intro: 'Rispondi a poche domande, carica una foto originale e guarda la tua carta prendere forma prima di acquistarla.',
      step: 'Passaggio', of: 'di', back: 'Indietro', next: 'Continua', generate: 'Genera la mia carta',
      stepTitles: ['Il tuo archetipo', 'Il tuo profilo', 'La tua carta', 'Controlla e genera'],
      stepLeads: ['Scegli che cosa rappresenta la carta e la sua direzione visiva.', 'Raccontaci come agisci e che cosa ti rende riconoscibile.', 'Dai un nome alla carta e carica l’immagine da trasformare.', 'Verifica le scelte e autorizza la generazione dell’anteprima.'],
      subjectKind: 'Soggetto dell’artwork', cardType: 'Tipo di carta', creatureSubtypes: 'Tipo/i di creatura', creatureSubtypesHint: 'Obbligatorio solo per Creatura. Esempio: Mago Umano.', role: 'Come ti definiresti?', style: 'Stile visivo', strength: 'Forza principale',
      colorIdentity: 'Colori della carta', colorIdentityHint: 'Scegli da 1 a 3 colori. Incolore è esclusivo. La scelta determina i simboli di mana e la cornice.', colorIdentityRequired: 'Scegli almeno un colore oppure Incolore.', colorIdentityLimit: 'Puoi scegliere al massimo 3 colori.', colorCount: '{count}/3 colori', colorLabels: { W: 'Bianco', U: 'Blu', B: 'Nero', R: 'Rosso', G: 'Verde', C: 'Incolore' },
      approach: 'Come affronti le sfide?', level: 'Livello attuale', motivation: 'Cosa ti guida?',
      cardName: 'Titolo della carta', phrase: 'Flavour — la frase che ti rappresenta',
      artworkContext: 'In quale contesto vuoi ambientare l’artwork?', finalSuggestion: 'Suggerimento finale (facoltativo)',
      photo: 'Carica una tua foto', photoHint: 'JPG, PNG o WebP, massimo 8 MB. Usa solo immagini di cui possiedi i diritti.',
      namePlaceholder: 'Es. Fè il distruttore', phrasePlaceholder: 'Es. Non distrugge persone: distrugge ostacoli.',
      contextPlaceholder: 'Es. sala di comando futuristica durante una tempesta energetica', suggestionPlaceholder: 'Es. rendilo autorevole ma umano, con un dettaglio ironico', choose: 'Seleziona',
      consent: 'Acconsento all’invio della foto e delle risposte a OpenAI esclusivamente per generare questa anteprima. Confermo di avere i diritti sull’immagine e di non caricare persone famose o contenuti offensivi.',
      privacy: 'Privacy policy', missing: 'Completa tutti i campi obbligatori prima di continuare.',
      invalidImage: 'Carica un’immagine JPG, PNG o WebP di massimo 8 MB.',
      generating: 'Stiamo creando la tua carta', generatingSub: 'Scriviamo il personaggio e trasformiamo l’immagine. Può richiedere fino a due minuti.',
      empty: 'Qui comparirà la tua anteprima', emptySub: 'La tua carta BizzyMagic completa: artwork personalizzato, abilità e valore distintivo.',
      edit: 'Modifica risposte', regenerate: 'Genera un’altra versione', add: 'Aggiungi al carrello', bundle: 'Set da 10 carte uguali',
      adding: 'Aggiunta al carrello…', demoNote: 'Anteprima demo: la trasformazione AI e l’acquisto saranno attivi dopo il collegamento sicuro dell’API.',
      liveNote: 'Anteprima digitale. La prova di stampa finale sarà verificata e approvata separatamente.',
      printApproval: 'Approvo questo esatto fronte e il retro standard BizzyMagic per la preparazione del file di stampa. So che 3 mm per lato sono abbondanza e verranno tagliati.',
      rawQaNote: 'Anteprima QA grezza: il controllo di Giacomo Venturi è temporaneamente sospeso. Non approvata per vendita o stampa.',
      apiMissing: 'Il servizio di generazione non è ancora configurato.', genericError: 'Non siamo riusciti a generare la carta. Riprova tra poco.',
      errorTitle: 'Generazione non completata', rateLimitTitle: 'Limite temporaneo raggiunto',
      rateLimitError: 'Hai raggiunto il limite temporaneo di generazioni.', retryMinutes: 'Puoi riprovare tra circa {count} min.', retryHours: 'Puoi riprovare tra circa {count} h.',
      rateLimited: (hours) => `Hai finito i tentativi, riprova tra ${hours} ${hours === 1 ? 'ora' : 'ore'}.`,
      reviewBlockedTitle: 'Questa richiesta non può essere generata', reviewBlockedMessage: 'Modifica i contenuti indicati e riprova. I blocchi riguardano soltanto sicurezza, diritti o contenuti incompatibili.',
      reviewUnavailableTitle: 'Verifica non completata', reviewUnavailableMessage: 'Non siamo riusciti a completare la verifica della carta. Puoi riprovare o segnalarci il problema qui sotto.',
      reportProblem: 'Segnala un problema', reportingProblem: 'Invio della segnalazione…', reportSent: 'Segnalazione inviata. Grazie!', reportDuplicate: 'Questa segnalazione è già stata ricevuta.', reportError: 'Non siamo riusciti a inviare la segnalazione. Riprova tra poco.',
      dataPreserved: 'Le risposte e la foto inserite sono ancora qui.',
      artworkError: 'L’artwork non è stato caricato. La generazione non è valida: riprova.', cartError: 'Non siamo riusciti ad aggiungere la carta al carrello.', contractUpgrade: 'Questa anteprima usa una versione di stampa precedente. Genera una nuova versione per approvare il fronte e il retro ufficiale.', ability: 'Talento', impact: 'Impatto', energy: 'Energia',
      summaryLabels: ['Tipo', 'Archetipo', 'Stile', 'Forza', 'Colori'],
      labels: {
        person: 'Persona', team: 'Team / Brand', creature: 'Creatura', instant: 'Istantaneo', sorcery: 'Stregoneria', artifact: 'Artefatto', enchantment: 'Incantesimo', land: 'Terra', creator: 'Creatore', leader: 'Leader', strategist: 'Stratega', executor: 'Esecutore', explorer: 'Esploratore', connector: 'Connettore',
        epic: 'Fantasy epico', realistic: 'Moderno / realistico', tech: 'Futuristico / tech', corporate: 'Elegante / corporate', creative: 'Ironico / creativo',
        creativity: 'Creatività', determination: 'Determinazione', intelligence: 'Intelligenza', empathy: 'Empatia', leadership: 'Leadership', precision: 'Precisione',
        direct: 'Diretto', strategic: 'Strategico', patient: 'Paziente', collaborative: 'Collaborativo', instinctive: 'Istintivo',
        growing: 'In crescita', solid: 'Solido', advanced: 'Avanzato', expert: 'Esperto', iconic: 'Iconico',
        improve: 'Migliorarmi', help: 'Aiutare gli altri', goals: 'Raggiungere obiettivi', create: 'Creare qualcosa di nuovo', experiences: 'Vivere nuove esperienze'
      }
    },
    en: {
      eyebrow: 'BizzyMagic AI builder', title: 'Create a card that genuinely feels like you',
      intro: 'Answer a few questions, upload an original photo and watch your card take shape before you buy.',
      step: 'Step', of: 'of', back: 'Back', next: 'Continue', generate: 'Generate my card',
      stepTitles: ['Your archetype', 'Your profile', 'Your card', 'Review and generate'],
      stepLeads: ['Choose what the card represents and its visual direction.', 'Tell us how you act and what makes you recognisable.', 'Name the card and upload the image to transform.', 'Review your choices and authorise preview generation.'],
      subjectKind: 'Artwork subject', cardType: 'Card type', creatureSubtypes: 'Creature subtype(s)', creatureSubtypesHint: 'Required only for Creature. Example: Human Wizard.', role: 'How would you define yourself?', style: 'Visual style', strength: 'Main strength',
      colorIdentity: 'Card colours', colorIdentityHint: 'Choose 1 to 3 colours. Colourless is exclusive. Your choice determines mana symbols and the frame.', colorIdentityRequired: 'Choose at least one colour or Colourless.', colorIdentityLimit: 'You can choose up to 3 colours.', colorCount: '{count}/3 colours', colorLabels: { W: 'White', U: 'Blue', B: 'Black', R: 'Red', G: 'Green', C: 'Colourless' },
      approach: 'How do you face challenges?', level: 'Current level', motivation: 'What drives you?',
      cardName: 'Card title', phrase: 'Flavour — a phrase that represents you',
      artworkContext: 'What setting should the artwork take place in?', finalSuggestion: 'Final suggestion (optional)', photo: 'Upload your photo',
      photoHint: 'JPG, PNG or WebP, up to 8 MB. Only use images you have the rights to.',
      namePlaceholder: 'E.g. Tommaso, the Connector', phrasePlaceholder: 'E.g. I turn every meeting into an opportunity',
      contextPlaceholder: 'E.g. a futuristic command room during an energy storm', suggestionPlaceholder: 'E.g. authoritative but human, with one playful detail',
      choose: 'Select', consent: 'I consent to sending my photo and answers to OpenAI solely to generate this preview. I confirm that I have the rights to the image and will not upload public figures or offensive content.',
      privacy: 'Privacy policy', missing: 'Complete all required fields before continuing.', invalidImage: 'Upload a JPG, PNG or WebP image up to 8 MB.',
      generating: 'We are creating your card', generatingSub: 'We are writing the character and transforming the image. This may take up to two minutes.',
      empty: 'Your preview will appear here', emptySub: 'Your complete BizzyMagic card: personalised artwork, abilities and signature value.',
      edit: 'Edit answers', regenerate: 'Generate another version', add: 'Add to cart', bundle: 'Set of 10 identical cards', adding: 'Adding to cart…',
      demoNote: 'Demo preview: AI transformation and purchase will be enabled after the API is securely connected.',
      liveNote: 'Digital preview. The final print proof will be reviewed and approved separately.', printApproval: 'I approve this exact front and the standard BizzyMagic back for print-file preparation. I understand that 3 mm on each side is bleed and will be trimmed.', rawQaNote: 'Raw QA preview: Giacomo Venturi review is temporarily suspended. Not approved for sale or print.', apiMissing: 'The generation service is not configured yet.', genericError: 'We could not generate the card. Please try again shortly.',
      errorTitle: 'Generation not completed', rateLimitTitle: 'Temporary limit reached',
      rateLimitError: 'You have reached the temporary generation limit.', retryMinutes: 'You can try again in about {count} min.', retryHours: 'You can try again in about {count} hr.',
      rateLimited: (hours) => `You have used all available attempts. Try again in ${hours} ${hours === 1 ? 'hour' : 'hours'}.`,
      reviewBlockedTitle: 'This request cannot be generated', reviewBlockedMessage: 'Change the requested content and try again. Hard blocks are limited to safety, rights or incompatible content.',
      reviewUnavailableTitle: 'Review not completed', reviewUnavailableMessage: 'We could not complete the card review. Try again or report the problem below.',
      reportProblem: 'Report a problem', reportingProblem: 'Sending report…', reportSent: 'Report sent. Thank you!', reportDuplicate: 'This report has already been received.', reportError: 'We could not send the report. Please try again shortly.',
      dataPreserved: 'Your answers and photo are still here.',
      artworkError: 'The artwork did not load. This generation is invalid; please try again.', cartError: 'We could not add the card to your cart.', contractUpgrade: 'This preview uses an earlier print contract. Generate a new version to approve the front and the official back.', ability: 'Talent', impact: 'Impact', energy: 'Energy', summaryLabels: ['Type', 'Archetype', 'Style', 'Strength', 'Colours'],
      labels: {
        person: 'Person', team: 'Team / Brand', creature: 'Creature', instant: 'Instant', sorcery: 'Sorcery', artifact: 'Artifact', enchantment: 'Enchantment', land: 'Land', creator: 'Creator', leader: 'Leader', strategist: 'Strategist', executor: 'Executor', explorer: 'Explorer', connector: 'Connector',
        epic: 'Epic fantasy', realistic: 'Modern / realistic', tech: 'Futuristic / tech', corporate: 'Elegant / corporate', creative: 'Playful / creative',
        creativity: 'Creativity', determination: 'Determination', intelligence: 'Intelligence', empathy: 'Empathy', leadership: 'Leadership', precision: 'Precision',
        direct: 'Direct', strategic: 'Strategic', patient: 'Patient', collaborative: 'Collaborative', instinctive: 'Instinctive',
        growing: 'Growing', solid: 'Solid', advanced: 'Advanced', expert: 'Expert', iconic: 'Iconic',
        improve: 'Improve myself', help: 'Help others', goals: 'Reach goals', create: 'Create something new', experiences: 'Live new experiences'
      }
    },
    fr: {
      eyebrow: 'Configurateur IA BizzyMagic', title: 'Créez une carte qui vous ressemble vraiment', intro: 'Répondez à quelques questions, importez une photo originale et découvrez votre carte avant l’achat.',
      step: 'Étape', of: 'sur', back: 'Retour', next: 'Continuer', generate: 'Générer ma carte', stepTitles: ['Votre archétype', 'Votre profil', 'Votre carte', 'Vérifier et générer'],
      stepLeads: ['Choisissez ce que représente la carte et sa direction visuelle.', 'Dites-nous comment vous agissez et ce qui vous distingue.', 'Nommez la carte et importez l’image à transformer.', 'Vérifiez vos choix et autorisez la génération de l’aperçu.'],
      subjectKind: 'Sujet de l’illustration', cardType: 'Type de carte', creatureSubtypes: 'Type(s) de créature', creatureSubtypesHint: 'Obligatoire uniquement pour Créature. Exemple : Humain Sorcier.', role: 'Comment vous définiriez-vous ?', style: 'Style visuel', strength: 'Force principale', approach: 'Comment relevez-vous les défis ?', level: 'Niveau actuel', motivation: 'Qu’est-ce qui vous motive ?',
      colorIdentity: 'Couleurs de la carte', colorIdentityHint: 'Choisissez de 1 à 3 couleurs. Incolore est exclusif. Ce choix détermine les symboles de mana et le cadre.', colorIdentityRequired: 'Choisissez au moins une couleur ou Incolore.', colorIdentityLimit: 'Vous pouvez choisir 3 couleurs maximum.', colorCount: '{count}/3 couleurs', colorLabels: { W: 'Blanc', U: 'Bleu', B: 'Noir', R: 'Rouge', G: 'Vert', C: 'Incolore' },
      cardName: 'Titre de la carte', phrase: 'Flavour — la phrase qui vous représente',
      artworkContext: 'Dans quel contexte situer l’illustration ?', finalSuggestion: 'Suggestion finale (facultatif)', photo: 'Importez votre photo', photoHint: 'JPG, PNG ou WebP, 8 Mo maximum. Utilisez uniquement des images dont vous détenez les droits.',
      namePlaceholder: 'Ex. Tommaso, le Connecteur', phrasePlaceholder: 'Ex. Je transforme chaque rencontre en opportunité',
      contextPlaceholder: 'Ex. salle de commandement futuriste pendant une tempête énergétique', suggestionPlaceholder: 'Ex. autoritaire mais humain, avec un détail ludique', choose: 'Sélectionner',
      consent: 'J’accepte que ma photo et mes réponses soient envoyées à OpenAI uniquement pour générer cet aperçu. Je confirme détenir les droits sur l’image et ne pas importer de personne célèbre ni de contenu offensant.', privacy: 'Politique de confidentialité',
      missing: 'Complétez tous les champs obligatoires avant de continuer.', invalidImage: 'Importez une image JPG, PNG ou WebP de 8 Mo maximum.', generating: 'Nous créons votre carte', generatingSub: 'Nous écrivons le personnage et transformons l’image. Cela peut prendre jusqu’à deux minutes.',
      empty: 'Votre aperçu apparaîtra ici', emptySub: 'Votre carte BizzyMagic complète : illustration personnalisée, capacités et valeur distinctive.', edit: 'Modifier les réponses', regenerate: 'Générer une autre version', add: 'Ajouter au panier', bundle: 'Lot de 10 cartes identiques', adding: 'Ajout au panier…',
      demoNote: 'Aperçu de démonstration : la transformation IA et l’achat seront activés après la connexion sécurisée de l’API.', liveNote: 'Aperçu numérique. Le bon à tirer final sera vérifié et approuvé séparément.', printApproval: 'J’approuve ce recto exact et le verso standard BizzyMagic pour la préparation du fichier d’impression. Je comprends que les 3 mm de chaque côté constituent le fond perdu et seront rognés.', rawQaNote: 'Aperçu QA brut : le contrôle de Giacomo Venturi est temporairement suspendu. Non approuvé pour la vente ou l’impression.', apiMissing: 'Le service de génération n’est pas encore configuré.', genericError: 'La carte n’a pas pu être générée. Réessayez dans quelques instants.', artworkError: 'L’illustration ne s’est pas chargée. Cette génération est invalide ; réessayez.', cartError: 'La carte n’a pas pu être ajoutée au panier.', contractUpgrade: 'Cet aperçu utilise un ancien contrat d’impression. Générez une nouvelle version pour approuver le recto et le verso officiel.', ability: 'Talent', impact: 'Impact', energy: 'Énergie', summaryLabels: ['Type', 'Archétype', 'Style', 'Force', 'Couleurs'],
      errorTitle: 'Génération non terminée', rateLimitTitle: 'Limite temporaire atteinte',
      rateLimitError: 'Vous avez atteint la limite temporaire de générations.', retryMinutes: 'Vous pourrez réessayer dans environ {count} min.', retryHours: 'Vous pourrez réessayer dans environ {count} h.',
      rateLimited: (hours) => `Vous avez utilisé toutes vos tentatives. Réessayez dans ${hours} ${hours === 1 ? 'heure' : 'heures'}.`,
      reviewBlockedTitle: 'Cette demande ne peut pas être générée', reviewBlockedMessage: 'Modifiez le contenu demandé puis réessayez. Les blocages concernent uniquement la sécurité, les droits ou un contenu incompatible.',
      reviewUnavailableTitle: 'Vérification incomplète', reviewUnavailableMessage: 'La vérification de la carte n’a pas pu être terminée. Réessayez ou signalez le problème ci-dessous.',
      reportProblem: 'Signaler un problème', reportingProblem: 'Envoi du signalement…', reportSent: 'Signalement envoyé. Merci !', reportDuplicate: 'Ce signalement a déjà été reçu.', reportError: 'Le signalement n’a pas pu être envoyé. Réessayez bientôt.',
      dataPreserved: 'Vos réponses et votre photo sont toujours présentes.',
      labels: {person:'Personne',team:'Équipe / Marque',creature:'Créature',instant:'Éphémère',sorcery:'Rituel',artifact:'Artefact',enchantment:'Enchantement',land:'Terrain',creator:'Créateur',leader:'Leader',strategist:'Stratège',executor:'Exécutant',explorer:'Explorateur',connector:'Connecteur',epic:'Fantasy épique',realistic:'Moderne / réaliste',tech:'Futuriste / tech',corporate:'Élégant / corporate',creative:'Ludique / créatif',creativity:'Créativité',determination:'Détermination',intelligence:'Intelligence',empathy:'Empathie',leadership:'Leadership',precision:'Précision',direct:'Direct',strategic:'Stratégique',patient:'Patient',collaborative:'Collaboratif',instinctive:'Instinctif',growing:'En progression',solid:'Solide',advanced:'Avancé',expert:'Expert',iconic:'Iconique',improve:'M’améliorer',help:'Aider les autres',goals:'Atteindre des objectifs',create:'Créer quelque chose de nouveau',experiences:'Vivre de nouvelles expériences'}
    },
    es: {
      eyebrow: 'Configurador IA BizzyMagic', title: 'Crea una carta que realmente hable de ti', intro: 'Responde a unas preguntas, sube una foto original y descubre tu carta antes de comprar.',
      step: 'Paso', of: 'de', back: 'Atrás', next: 'Continuar', generate: 'Generar mi carta', stepTitles: ['Tu arquetipo', 'Tu perfil', 'Tu carta', 'Revisar y generar'],
      stepLeads: ['Elige qué representa la carta y su dirección visual.', 'Cuéntanos cómo actúas y qué te hace reconocible.', 'Pon nombre a la carta y sube la imagen que transformaremos.', 'Revisa tus elecciones y autoriza la generación de la vista previa.'],
      subjectKind: 'Sujeto del artwork', cardType: 'Tipo de carta', creatureSubtypes: 'Tipo(s) de criatura', creatureSubtypesHint: 'Obligatorio solo para Criatura. Ejemplo: Humano Hechicero.', role: '¿Cómo te definirías?', style: 'Estilo visual', strength: 'Fortaleza principal', approach: '¿Cómo afrontas los retos?', level: 'Nivel actual', motivation: '¿Qué te impulsa?',
      colorIdentity: 'Colores de la carta', colorIdentityHint: 'Elige de 1 a 3 colores. Incoloro es exclusivo. La elección determina los símbolos de maná y el marco.', colorIdentityRequired: 'Elige al menos un color o Incoloro.', colorIdentityLimit: 'Puedes elegir un máximo de 3 colores.', colorCount: '{count}/3 colores', colorLabels: { W: 'Blanco', U: 'Azul', B: 'Negro', R: 'Rojo', G: 'Verde', C: 'Incoloro' },
      cardName: 'Título de la carta', phrase: 'Flavour — la frase que te representa',
      artworkContext: '¿En qué contexto debe ambientarse la ilustración?', finalSuggestion: 'Sugerencia final (opcional)', photo: 'Sube tu foto', photoHint: 'JPG, PNG o WebP, máximo 8 MB. Usa solo imágenes cuyos derechos poseas.',
      namePlaceholder: 'Ej. Tommaso, el Conector', phrasePlaceholder: 'Ej. Convierto cada encuentro en una oportunidad',
      contextPlaceholder: 'Ej. sala de mando futurista durante una tormenta de energía', suggestionPlaceholder: 'Ej. autoritario pero humano, con un detalle divertido', choose: 'Seleccionar',
      consent: 'Acepto enviar mi foto y mis respuestas a OpenAI únicamente para generar esta vista previa. Confirmo que tengo los derechos de la imagen y que no subiré personas famosas ni contenido ofensivo.', privacy: 'Política de privacidad',
      missing: 'Completa todos los campos obligatorios antes de continuar.', invalidImage: 'Sube una imagen JPG, PNG o WebP de hasta 8 MB.', generating: 'Estamos creando tu carta', generatingSub: 'Estamos escribiendo el personaje y transformando la imagen. Puede tardar hasta dos minutos.',
      empty: 'Tu vista previa aparecerá aquí', emptySub: 'Tu carta BizzyMagic completa: ilustración personalizada, habilidades y valor distintivo.', edit: 'Editar respuestas', regenerate: 'Generar otra versión', add: 'Añadir al carrito', bundle: 'Set de 10 cartas idénticas', adding: 'Añadiendo al carrito…',
      demoNote: 'Vista previa de demostración: la transformación IA y la compra se activarán tras conectar la API de forma segura.', liveNote: 'Vista previa digital. La prueba final de impresión se revisará y aprobará por separado.', printApproval: 'Apruebo este anverso exacto y el reverso estándar BizzyMagic para preparar el archivo de impresión. Entiendo que los 3 mm de cada lado son sangrado y se recortarán.', rawQaNote: 'Vista previa QA sin filtrar: la revisión de Giacomo Venturi está temporalmente suspendida. No aprobada para venta o impresión.', apiMissing: 'El servicio de generación aún no está configurado.', genericError: 'No hemos podido generar la carta. Inténtalo de nuevo en unos instantes.', artworkError: 'La ilustración no se ha cargado. Esta generación no es válida; inténtalo de nuevo.', cartError: 'No hemos podido añadir la carta al carrito.', contractUpgrade: 'Esta vista previa usa un contrato de impresión anterior. Genera una nueva versión para aprobar el anverso y el reverso oficial.', ability: 'Talento', impact: 'Impacto', energy: 'Energía', summaryLabels: ['Tipo', 'Arquetipo', 'Estilo', 'Fortaleza', 'Colores'],
      errorTitle: 'Generación no completada', rateLimitTitle: 'Límite temporal alcanzado',
      rateLimitError: 'Has alcanzado el límite temporal de generaciones.', retryMinutes: 'Podrás volver a intentarlo en unos {count} min.', retryHours: 'Podrás volver a intentarlo en unas {count} h.',
      rateLimited: (hours) => `Has agotado los intentos disponibles. Inténtalo de nuevo en ${hours} ${hours === 1 ? 'hora' : 'horas'}.`,
      reviewBlockedTitle: 'Esta solicitud no se puede generar', reviewBlockedMessage: 'Modifica el contenido solicitado e inténtalo de nuevo. Los bloqueos se limitan a seguridad, derechos o contenido incompatible.',
      reviewUnavailableTitle: 'Revisión no completada', reviewUnavailableMessage: 'No hemos podido completar la revisión de la carta. Inténtalo de nuevo o informa del problema abajo.',
      reportProblem: 'Informar de un problema', reportingProblem: 'Enviando informe…', reportSent: 'Informe enviado. ¡Gracias!', reportDuplicate: 'Este informe ya se ha recibido.', reportError: 'No hemos podido enviar el informe. Inténtalo de nuevo más tarde.',
      dataPreserved: 'Tus respuestas y tu foto siguen aquí.',
      labels: {person:'Persona',team:'Equipo / Marca',creature:'Criatura',instant:'Instantáneo',sorcery:'Conjuro',artifact:'Artefacto',enchantment:'Encantamiento',land:'Tierra',creator:'Creador',leader:'Líder',strategist:'Estratega',executor:'Ejecutor',explorer:'Explorador',connector:'Conector',epic:'Fantasía épica',realistic:'Moderno / realista',tech:'Futurista / tech',corporate:'Elegante / corporativo',creative:'Divertido / creativo',creativity:'Creatividad',determination:'Determinación',intelligence:'Inteligencia',empathy:'Empatía',leadership:'Liderazgo',precision:'Precisión',direct:'Directo',strategic:'Estratégico',patient:'Paciente',collaborative:'Colaborativo',instinctive:'Instintivo',growing:'En crecimiento',solid:'Sólido',advanced:'Avanzado',expert:'Experto',iconic:'Icónico',improve:'Mejorarme',help:'Ayudar a los demás',goals:'Alcanzar objetivos',create:'Crear algo nuevo',experiences:'Vivir nuevas experiencias'}
    }
  };

  const escapeAttribute = (value) => String(value).replaceAll('&', '&amp;').replaceAll('"', '&quot;').replaceAll('<', '&lt;').replaceAll('>', '&gt;');

  class BizzyMagicCardBuilder {
    constructor(root) {
      this.root = root;
      const locale = (root.dataset.locale || 'en').split('-')[0];
      this.t = copy[locale] || copy.en;
      this.locale = locale;
      this.step = 0;
      this.file = null;
      this.selectedColours = [];
      this.result = null;
      this.lastGenerationError = null;
      this.problemReportId = crypto.randomUUID();
      this.problemReportTimer = null;
      this.generating = false;
      this.demoMode = root.dataset.demoMode === 'true';
      this.cartEnabled = root.dataset.cartEnabled === 'true';
      this.variantId = Number(root.dataset.variantId);
      this.packSize = Number(root.dataset.packSize);
      this.priceCents = Number(root.dataset.priceCents);
      this.apiEndpoint = (root.dataset.apiEndpoint || '').trim();
      this.turnstileSiteKey = (root.dataset.turnstileSitekey || '').trim();
      this.render();
    }

    optionList(group) {
      return `<option value="">${this.t.choose}</option>${options[group].map((value) => `<option value="${value}">${this.t.labels[value]}</option>`).join('')}`;
    }

    field(name, label, group) {
      return `<div class="bizzy-card-builder__field"><label for="bizzy-${name}">${label}</label><select id="bizzy-${name}" name="${name}" required>${this.optionList(group)}</select></div>`;
    }

    colorSelector() {
      const choices = [...COLOR_ORDER, 'C'].map((token) => {
        const symbol = token === 'C'
          ? '<span class="bizzy-card-builder__colorless-symbol" aria-hidden="true">◇</span>'
          : `<img src="${escapeAttribute(MANA_ASSET_URLS[token])}" alt="" width="32" height="32" loading="eager">`;
        return `<button type="button" class="bizzy-card-builder__color-option" data-color-choice="${token}" aria-pressed="false"><span class="bizzy-card-builder__color-symbol">${symbol}</span><span>${this.t.colorLabels[token]}</span></button>`;
      }).join('');
      return `<fieldset class="bizzy-card-builder__color-field bizzy-card-builder__field--wide"><legend class="bizzy-card-builder__legend">${this.t.colorIdentity}</legend><p class="bizzy-card-builder__hint">${this.t.colorIdentityHint}</p><div class="bizzy-card-builder__color-grid">${choices}</div><input type="hidden" name="colorIdentity" data-color-identity><div class="bizzy-card-builder__color-meta"><span data-color-count aria-live="polite"></span><span data-color-error role="alert"></span></div></fieldset>`;
    }

    render() {
      const t = this.t;
      this.root.innerHTML = `
        <div class="bizzy-card-builder">
          <header class="bizzy-card-builder__intro">
            <p class="bizzy-card-builder__eyebrow">${t.eyebrow}</p>
            <h2>${t.title}</h2>
            <p>${t.intro}</p>
          </header>
          <div class="bizzy-card-builder__layout">
            <form class="bizzy-card-builder__panel" data-builder-form novalidate>
              <div class="bizzy-card-builder__progress-meta"><span data-step-label></span><span data-step-title></span></div>
              <div class="bizzy-card-builder__progress" aria-hidden="true"><span data-progress-bar></span></div>

              <section class="bizzy-card-builder__step" data-step="0">
                <h3>${t.stepTitles[0]}</h3><p class="bizzy-card-builder__step-lead">${t.stepLeads[0]}</p>
                <div class="bizzy-card-builder__fields">
                  ${this.field('subjectKind', t.subjectKind, 'subjectKind')}${this.field('cardType', t.cardType, 'cardType')}${this.field('role', t.role, 'role')}${this.field('style', t.style, 'style')}
                  <div class="bizzy-card-builder__field bizzy-card-builder__field--wide" data-creature-subtypes hidden><label for="bizzy-creature-subtypes">${t.creatureSubtypes}</label><input id="bizzy-creature-subtypes" name="creatureSubtypes" maxlength="48"><p class="bizzy-card-builder__hint">${t.creatureSubtypesHint}</p></div>
                  ${this.colorSelector()}
                </div>
              </section>
              <section class="bizzy-card-builder__step" data-step="1" hidden>
                <h3>${t.stepTitles[1]}</h3><p class="bizzy-card-builder__step-lead">${t.stepLeads[1]}</p>
                <div class="bizzy-card-builder__fields">${this.field('strength', t.strength, 'strength')}${this.field('approach', t.approach, 'approach')}${this.field('level', t.level, 'level')}${this.field('motivation', t.motivation, 'motivation')}</div>
              </section>
              <section class="bizzy-card-builder__step" data-step="2" hidden>
                <h3>${t.stepTitles[2]}</h3><p class="bizzy-card-builder__step-lead">${t.stepLeads[2]}</p>
                <div class="bizzy-card-builder__fields">
                  <div class="bizzy-card-builder__field bizzy-card-builder__field--wide"><label for="bizzy-card-name">${t.cardName}</label><input id="bizzy-card-name" name="cardName" maxlength="52" placeholder="${escapeAttribute(t.namePlaceholder)}" required></div>
                  <div class="bizzy-card-builder__field bizzy-card-builder__field--wide"><label for="bizzy-phrase">${t.phrase}</label><textarea id="bizzy-phrase" name="phrase" maxlength="180" placeholder="${escapeAttribute(t.phrasePlaceholder)}" required></textarea></div>
                  <div class="bizzy-card-builder__field bizzy-card-builder__field--wide"><label for="bizzy-artwork-context">${t.artworkContext}</label><textarea id="bizzy-artwork-context" name="artworkContext" maxlength="240" placeholder="${escapeAttribute(t.contextPlaceholder)}" required></textarea></div>
                  <div class="bizzy-card-builder__field bizzy-card-builder__field--wide"><label for="bizzy-final-suggestion">${t.finalSuggestion}</label><textarea id="bizzy-final-suggestion" name="finalSuggestion" maxlength="240" placeholder="${escapeAttribute(t.suggestionPlaceholder)}"></textarea></div>
                  <div class="bizzy-card-builder__field bizzy-card-builder__field--wide"><label for="bizzy-photo">${t.photo}</label><input id="bizzy-photo" name="photo" type="file" accept="image/jpeg,image/png,image/webp" required><p class="bizzy-card-builder__hint">${t.photoHint}</p></div>
                </div>
              </section>
              <section class="bizzy-card-builder__step" data-step="3" hidden>
                <h3>${t.stepTitles[3]}</h3><p class="bizzy-card-builder__step-lead">${t.stepLeads[3]}</p>
                <dl class="bizzy-card-builder__summary" data-summary></dl>
                <label class="bizzy-card-builder__consent"><input type="checkbox" name="consent" required><span>${t.consent} <a href="${escapeAttribute(this.root.dataset.privacyUrl || '#')}" target="_blank" rel="noopener">${t.privacy}</a>.</span></label>
                ${this.turnstileSiteKey ? `<div class="cf-turnstile" data-sitekey="${escapeAttribute(this.turnstileSiteKey)}" data-action="generate-card" data-theme="auto"></div>` : ''}
              </section>
              <p class="bizzy-card-builder__error" data-builder-error role="alert"></p>
              <div class="bizzy-card-builder__actions">
                <button class="bizzy-card-builder__button bizzy-card-builder__button--secondary" type="button" data-back hidden>${t.back}</button>
                <button class="bizzy-card-builder__button" type="button" data-next>${t.next}</button>
              </div>
            </form>

            <aside class="bizzy-card-builder__stage" aria-live="polite">
              <div class="bizzy-card-builder__empty" data-empty-preview><span class="bizzy-card-builder__empty-mark" aria-hidden="true">B</span><strong>${t.empty}</strong><p>${t.emptySub}</p></div>
              <div class="bizzy-card-builder__loading-state" data-loading-preview hidden><span class="bizzy-card-builder__spinner" aria-hidden="true"></span><strong>${t.generating}</strong><p>${t.generatingSub}</p></div>
              <div class="bizzy-card-builder__error-state" data-error-preview hidden><span class="bizzy-card-builder__empty-mark" aria-hidden="true">!</span><strong data-error-preview-title>${t.errorTitle}</strong><p data-error-preview-message></p></div>
              <div class="bizzy-card-builder__preview" data-preview hidden>
                <div class="bizzy-card-builder__card-viewport">
                  <article class="bizzy-card-builder__card" data-color-identity="C" data-card-kind="noncreature" aria-label="BizzyMagic card preview">
                    <div class="bizzy-card-builder__card-frame">
                      <header class="bizzy-card-builder__card-titlebar">
                        <strong data-card-name></strong>
                        <span class="bizzy-card-builder__mana-cost" data-mana-cost aria-label="Costo di mana"></span>
                      </header>
                      <figure class="bizzy-card-builder__art"><img data-card-art alt=""><span aria-hidden="true"></span></figure>
                      <section class="bizzy-card-builder__lore" aria-label="Card details">
                        <div class="bizzy-card-builder__type"><strong data-card-type></strong><span class="bizzy-card-builder__rarity" aria-label="BizzyMagic rare">⬡</span></div>
                        <div class="bizzy-card-builder__rules">
                          <div class="bizzy-card-builder__ability" data-card-ability="0"><p><span data-ability-text></span></p></div>
                          <div class="bizzy-card-builder__ability" data-card-ability="1"><p><span data-ability-text></span></p></div>
                          <p class="bizzy-card-builder__flavour" data-flavour></p>
                        </div>
                        <footer class="bizzy-card-builder__card-footer"><span>2220 · ITA</span><b>BIZZYMAGIC</b><span>ORIGINAL</span></footer>
                      </section>
                      <div class="bizzy-card-builder__combat-stats" aria-label="Power and toughness"><b data-combat-stats></b></div>
                    </div>
                  </article>
                </div>
                <p class="bizzy-card-builder__preview-note" data-preview-note></p>
                <div class="bizzy-card-builder__actions">
                  <button class="bizzy-card-builder__button bizzy-card-builder__button--secondary" type="button" data-edit>${t.edit}</button>
                  <button class="bizzy-card-builder__button bizzy-card-builder__button--secondary" type="button" data-regenerate>${t.regenerate}</button>
                  <div class="bizzy-card-builder__buy-box">
                    <p><strong>${t.bundle}</strong><span>${escapeAttribute(this.root.dataset.priceLabel || '')}</span></p>
                    <label class="bizzy-card-builder__print-approval"><input type="checkbox" data-print-approval><span>${t.printApproval}</span></label>
                    <button class="bizzy-card-builder__button" type="button" data-add-cart>${t.add}</button>
                  </div>
                </div>
              </div>
              <div class="bizzy-card-builder__problem-report">
                <button class="bizzy-card-builder__problem-button" type="button" data-report-problem>${t.reportProblem}</button>
                <p data-report-status role="status" aria-live="polite"></p>
              </div>
            </aside>
          </div>
        </div>`;

      this.form = this.root.querySelector('[data-builder-form]');
      this.error = this.root.querySelector('[data-builder-error]');
      this.cardElements = {
        preview: this.root.querySelector('[data-preview]'),
        empty: this.root.querySelector('[data-empty-preview]'),
        loading: this.root.querySelector('[data-loading-preview]'),
        errorState: this.root.querySelector('[data-error-preview]'),
        errorTitle: this.root.querySelector('[data-error-preview-title]'),
        errorMessage: this.root.querySelector('[data-error-preview-message]'),
        stage: this.root.querySelector('.bizzy-card-builder__stage'),
        card: this.root.querySelector('.bizzy-card-builder__card'),
        frame: this.root.querySelector('.bizzy-card-builder__card-frame'),
        art: this.root.querySelector('.bizzy-card-builder__art'),
        image: this.root.querySelector('[data-card-art]'),
        titlebar: this.root.querySelector('.bizzy-card-builder__card-titlebar'),
        title: this.root.querySelector('[data-card-name]'),
        mana: this.root.querySelector('[data-mana-cost]'),
        lore: this.root.querySelector('.bizzy-card-builder__lore'),
        type: this.root.querySelector('[data-card-type]'),
        rules: this.root.querySelector('.bizzy-card-builder__rules'),
        flavour: this.root.querySelector('[data-flavour]'),
        footer: this.root.querySelector('.bizzy-card-builder__card-footer'),
        stats: this.root.querySelector('.bizzy-card-builder__combat-stats'),
        statsText: this.root.querySelector('[data-combat-stats]'),
        abilities: [...this.root.querySelectorAll('[data-card-ability]')],
        note: this.root.querySelector('[data-preview-note]'),
        printApproval: this.root.querySelector('[data-print-approval]'),
        addCart: this.root.querySelector('[data-add-cart]'),
        reportButton: this.root.querySelector('[data-report-problem]'),
        reportStatus: this.root.querySelector('[data-report-status]'),
      };
      this.form.addEventListener('submit', (event) => event.preventDefault());
      this.root.querySelector('[data-next]').addEventListener('click', () => this.next());
      this.root.querySelector('[data-back]').addEventListener('click', () => this.showStep(this.step - 1));
      this.root.querySelector('[data-edit]').addEventListener('click', () => this.edit());
      this.root.querySelector('[data-regenerate]').addEventListener('click', () => this.generate());
      this.root.querySelector('[data-add-cart]').addEventListener('click', () => this.addToCart());
      this.root.querySelector('[data-report-problem]').addEventListener('click', () => this.reportProblem());
      this.cardElements.printApproval.addEventListener('change', () => this.syncAddToCartState());
      this.form.elements.photo.addEventListener('change', (event) => { this.file = event.target.files?.[0] || null; });
      this.form.elements.cardType.addEventListener('change', () => this.syncCreatureSubtypeField());
      this.root.querySelectorAll('[data-color-choice]').forEach((button) => {
        button.addEventListener('click', () => this.toggleColour(button.dataset.colorChoice));
      });
      this.syncCreatureSubtypeField();
      this.syncColourSelector();
      this.showStep(0);
    }

    toggleColour(token) {
      const error = this.root.querySelector('[data-color-error]');
      error.textContent = '';
      if (token === 'C') {
        this.selectedColours = this.selectedColours.length === 1 && this.selectedColours[0] === 'C' ? [] : ['C'];
      } else {
        this.selectedColours = this.selectedColours.filter((value) => value !== 'C');
        if (this.selectedColours.includes(token)) {
          this.selectedColours = this.selectedColours.filter((value) => value !== token);
        } else if (this.selectedColours.length >= 3) {
          error.textContent = this.t.colorIdentityLimit;
          return;
        } else {
          this.selectedColours = COLOR_ORDER.filter((value) => [...this.selectedColours, token].includes(value));
        }
      }
      this.syncColourSelector();
    }

    syncColourSelector() {
      this.form.elements.colorIdentity.value = this.selectedColours.join(',');
      this.root.querySelectorAll('[data-color-choice]').forEach((button) => {
        button.setAttribute('aria-pressed', String(this.selectedColours.includes(button.dataset.colorChoice)));
      });
      const count = this.selectedColours.includes('C') ? 0 : this.selectedColours.length;
      this.root.querySelector('[data-color-count]').textContent = this.selectedColours.includes('C')
        ? this.t.colorLabels.C
        : this.t.colorCount.replace('{count}', String(count));
    }

    formatColourIdentity(value) {
      const tokens = String(value || '').split(',').filter(Boolean);
      return tokens.map((token) => this.t.colorLabels[token] || token).join(' + ');
    }

    syncCreatureSubtypeField() {
      const wrapper = this.root.querySelector('[data-creature-subtypes]');
      const input = this.form.elements.creatureSubtypes;
      const isCreature = this.form.elements.cardType.value === 'creature';
      wrapper.hidden = !isCreature;
      input.required = isCreature;
      if (!isCreature) input.value = '';
    }

    currentFields() {
      return [...this.root.querySelector(`[data-step="${this.step}"]`).querySelectorAll('input,select,textarea')];
    }

    validateCurrentStep() {
      this.error.textContent = '';
      for (const field of this.currentFields()) {
        if (!field.checkValidity()) {
          field.reportValidity();
          this.error.textContent = this.t.missing;
          return false;
        }
      }
      if (this.step === 0 && !this.selectedColours.length) {
        this.root.querySelector('[data-color-error]').textContent = this.t.colorIdentityRequired;
        this.error.textContent = this.t.colorIdentityRequired;
        return false;
      }
      if (this.step === 2 && (!this.file || !ALLOWED_IMAGE_TYPES.includes(this.file.type) || this.file.size > MAX_IMAGE_BYTES)) {
        this.error.textContent = this.t.invalidImage;
        return false;
      }
      return true;
    }

    next() {
      if (!this.validateCurrentStep()) return;
      if (this.step < 3) this.showStep(this.step + 1);
      else this.generate();
    }

    showStep(nextStep) {
      this.step = Math.max(0, Math.min(3, nextStep));
      this.error.textContent = '';
      this.root.querySelectorAll('[data-step]').forEach((panel) => { panel.hidden = Number(panel.dataset.step) !== this.step; });
      this.root.querySelector('[data-back]').hidden = this.step === 0;
      const next = this.root.querySelector('[data-next]');
      next.textContent = this.step === 3 ? this.t.generate : this.t.next;
      this.root.querySelector('[data-step-label]').textContent = `${this.t.step} ${this.step + 1} ${this.t.of} 4`;
      this.root.querySelector('[data-step-title]').textContent = this.t.stepTitles[this.step];
      this.root.querySelector('[data-progress-bar]').style.width = `${(this.step + 1) * 25}%`;
      if (this.step === 3) this.syncSummary();
    }

    values() {
      const data = Object.fromEntries(new FormData(this.form).entries());
      delete data.photo;
      data.locale = this.locale;
      data.consent = Boolean(this.form.elements.consent.checked);
      return data;
    }

    syncSummary() {
      const values = this.values();
      const entries = [['cardType', values.cardType], ['role', values.role], ['style', values.style], ['strength', values.strength], ['colorIdentity', values.colorIdentity]];
      const summary = this.root.querySelector('[data-summary]');
      summary.innerHTML = '';
      entries.forEach(([key, value], index) => {
        const item = document.createElement('div');
        const dt = document.createElement('dt');
        const dd = document.createElement('dd');
        dt.textContent = this.t.summaryLabels[index];
        dd.textContent = key === 'colorIdentity' ? this.formatColourIdentity(value) : (this.t.labels[value] || value);
        item.append(dt, dd);
        summary.append(item);
      });
    }

    async generate() {
      if (this.generating) return;
      if (this.step !== 3) this.showStep(3);
      if (!this.validateCurrentStep()) return;
      const previousResult = this.result;
      this.generating = true;
      const nextButton = this.root.querySelector('[data-next]');
      const regenerateButton = this.root.querySelector('[data-regenerate]');
      nextButton.disabled = true;
      regenerateButton.disabled = true;
      this.error.textContent = '';
      this.cardElements.errorTitle.textContent = this.t.errorTitle;
      this.cardElements.errorMessage.textContent = '';
      this.setPreviewState('loading');
      try {
        const result = this.demoMode ? await this.demoResult() : await this.apiResult();
        this.result = result;
        this.lastGenerationError = null;
        this.renderPreview(result);
      } catch (error) {
        this.result = previousResult;
        this.lastGenerationError = {
          code: String(error?.code || 'generation_failed'),
          status: Number(error?.status) || null,
          message: String(error?.message || this.t.genericError),
          reviewReference: String(error?.reviewReference || ''),
          requestId: String(error?.requestId || ''),
        };
        const presentation = this.presentGenerationError(error);
        this.error.textContent = presentation.message;
        this.cardElements.errorTitle.textContent = presentation.title;
        this.cardElements.errorMessage.textContent = presentation.message;
        this.setPreviewState('error');
      } finally {
        this.generating = false;
        nextButton.disabled = false;
        regenerateButton.disabled = false;
      }
    }

    async apiResult() {
      if (!this.apiEndpoint) throw new Error(this.t.apiMissing);
      const payload = new FormData();
      const values = this.values();
      Object.entries(values).forEach(([key, value]) => payload.append(key, String(value)));
      payload.append('photo', this.file, this.file.name);
      const requestId = crypto.randomUUID();
      try {
        const response = await fetch(this.apiEndpoint, {
          method: 'POST',
          body: payload,
          headers: { Accept: 'application/json', 'Idempotency-Key': requestId },
        });
        const body = await response.json().catch(() => ({}));
        if (!response.ok) {
          const error = new Error(body.message || this.t.genericError);
          const retryAfterHeader = response.headers.get('Retry-After');
          const retryAfterSeconds = Number(body.retryAfterSeconds) || this.parseRetryAfter(retryAfterHeader);
          error.code = String(body.code || 'generation_failed');
          error.status = response.status;
          error.retryAfterSeconds = Number.isFinite(retryAfterSeconds) && retryAfterSeconds > 0 ? Math.ceil(retryAfterSeconds) : null;
          error.retryAfterHours = Number(body.retryAfterHours) || null;
          error.reviewReference = String(body.reviewReference || '');
          error.requestId = requestId;
          throw error;
        }
        return body;
      } finally {
        window.turnstile?.reset();
      }
    }

    parseRetryAfter(value) {
      if (!value) return null;
      const seconds = Number(value);
      if (Number.isFinite(seconds) && seconds > 0) return seconds;
      const date = Date.parse(value);
      return Number.isFinite(date) ? Math.max(1, Math.ceil((date - Date.now()) / 1000)) : null;
    }

    retryTiming(seconds) {
      if (!Number.isFinite(seconds) || seconds <= 0) return '';
      const minutes = Math.max(1, Math.ceil(seconds / 60));
      if (minutes < 60) return this.t.retryMinutes.replace('{count}', String(minutes));
      return this.t.retryHours.replace('{count}', String(Math.ceil(minutes / 60)));
    }

    startProblemReportCooldown(button, seconds) {
      window.clearTimeout(this.problemReportTimer);
      button.disabled = true;
      this.problemReportTimer = window.setTimeout(() => {
        button.disabled = false;
        this.problemReportTimer = null;
      }, Math.max(1, Math.min(3600, Number(seconds) || 300)) * 1000);
    }

    presentGenerationError(error) {
      const isRateLimited = error?.status === 429
        || ['rate_limited', 'attempt_rate_limited', 'daily_generation_limit', 'daily_attempt_limit', 'generation_busy'].includes(error?.code);
      if (isRateLimited) {
        const hours = Math.max(1, Number(error?.retryAfterHours) || Math.ceil((Number(error?.retryAfterSeconds) || 3600) / 3600));
        return {
          title: this.t.rateLimitTitle,
          message: [this.t.rateLimited(hours), this.t.dataPreserved].filter(Boolean).join(' '),
        };
      }
      if (error?.code === 'review_blocked') {
        return { title: this.t.reviewBlockedTitle, message: this.t.reviewBlockedMessage };
      }
      if (error?.code === 'review_hold') {
        return { title: this.t.reviewUnavailableTitle, message: this.t.reviewUnavailableMessage };
      }
      return { title: this.t.errorTitle, message: error?.message || this.t.genericError };
    }

    async demoResult() {
      const values = this.values();
      const artUrl = await this.createDemoArtwork(this.file, values);
      const levelScores = { growing: 2, solid: 3, advanced: 4, expert: 5, iconic: 6 };
      const selectedColorIdentity = values.colorIdentity === 'C' ? ['C'] : values.colorIdentity.split(',').filter((token) => COLOR_ORDER.includes(token));
      const colorIdentity = selectedColorIdentity.includes('C') ? [] : selectedColorIdentity;
      const generic = values.cardType === 'artifact' ? Math.max(2, levelScores[values.level]) : levelScores[values.level];
      const manaCost = values.cardType === 'land' ? [] : [generic, ...colorIdentity];
      const typeLine = `${this.t.labels[values.cardType]}${values.cardType === 'creature' ? ` — ${values.creatureSubtypes}` : ''}`;
      return {
        draftId: null,
        previewUrl: null,
        artUrl,
        card: {
          cardName: values.cardName,
          manaCost,
          colorIdentity,
          selectedColorIdentity,
          typeLine,
          abilities: [
            { templateId: 'keyword_volare', params: {}, text: 'Volare' },
            { templateId: 'etb_draw', params: { count: 1 }, text: `Quando ${values.cardName} entra nel campo di battaglia, pesca una carta.` },
          ],
          flavourText: values.phrase,
          power: values.cardType === 'creature' ? Math.max(1, levelScores[values.level] - 1) : null,
          toughness: values.cardType === 'creature' ? levelScores[values.level] : null,
        },
      };
    }

    async createDemoArtwork(file, values) {
      const source = await this.readFile(file);
      const image = await new Promise((resolve, reject) => {
        const element = new Image();
        element.onload = () => resolve(element);
        element.onerror = () => reject(new Error(this.t.invalidImage));
        element.src = source;
      });
      const canvas = document.createElement('canvas');
      canvas.width = 1024;
      canvas.height = 1536;
      const context = canvas.getContext('2d');
      const palettes = {
        epic: ['#311568', '#d59a34'], realistic: ['#402719', '#d6a45c'], tech: ['#071d36', '#23bde8'],
        corporate: ['#25221c', '#c8ae70'], creative: ['#4b1441', '#ff72bd'],
      };
      const [deep, accent] = palettes[values.style] || palettes.epic;
      const scale = Math.max(canvas.width / image.width, canvas.height / image.height);
      const width = image.width * scale;
      const height = image.height * scale;
      context.fillStyle = deep;
      context.fillRect(0, 0, canvas.width, canvas.height);
      context.filter = values.style === 'realistic' ? 'contrast(1.08) saturate(.92)' : 'contrast(1.12) saturate(1.18)';
      context.drawImage(image, (canvas.width - width) / 2, (canvas.height - height) / 2, width, height);
      context.filter = 'none';

      const wash = context.createLinearGradient(0, 0, canvas.width, canvas.height);
      wash.addColorStop(0, `${deep}d0`);
      wash.addColorStop(.48, 'rgba(0,0,0,0)');
      wash.addColorStop(1, `${accent}86`);
      context.fillStyle = wash;
      context.fillRect(0, 0, canvas.width, canvas.height);

      context.save();
      context.globalCompositeOperation = 'screen';
      context.strokeStyle = `${accent}99`;
      context.fillStyle = `${accent}66`;
      context.lineWidth = 4;
      const motifCount = values.level === 'iconic' ? 9 : values.level === 'expert' ? 7 : 5;
      for (let index = 0; index < motifCount; index += 1) {
        const x = 120 + ((index * 271) % 1290);
        const y = 110 + ((index * 173) % 760);
        const radius = values.role === 'strategist' || values.strength === 'intelligence' ? 42 + index * 8 : 11 + index * 3;
        context.beginPath();
        context.arc(x, y, radius, 0, Math.PI * 2);
        values.approach === 'strategic' ? context.stroke() : context.fill();
      }
      if (values.subjectKind === 'artifact') {
        context.translate(canvas.width * .76, canvas.height * .38);
        context.rotate(Math.PI / 4);
        context.strokeRect(-95, -95, 190, 190);
        context.strokeRect(-65, -65, 130, 130);
      }
      context.restore();

      const vignette = context.createRadialGradient(canvas.width / 2, canvas.height / 2, 220, canvas.width / 2, canvas.height / 2, 880);
      vignette.addColorStop(.42, 'rgba(0,0,0,0)');
      vignette.addColorStop(1, 'rgba(3,2,8,.74)');
      context.fillStyle = vignette;
      context.fillRect(0, 0, canvas.width, canvas.height);
      return canvas.toDataURL('image/webp', .9);
    }

    readFile(file) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onload = () => resolve(reader.result);
        reader.onerror = () => reject(new Error(this.t.invalidImage));
        reader.readAsDataURL(file);
      });
    }

    readBlob(blob) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onload = () => resolve(reader.result);
        reader.onerror = () => reject(new Error(this.t.reportError));
        reader.readAsDataURL(blob);
      });
    }

    async imageDataUrl(image) {
      if (image.complete && image.naturalWidth && image.naturalHeight) {
        try {
          const canvas = document.createElement('canvas');
          canvas.width = image.naturalWidth;
          canvas.height = image.naturalHeight;
          canvas.getContext('2d').drawImage(image, 0, 0);
          return canvas.toDataURL('image/png');
        } catch {
          // Retry through a CORS fetch below.
        }
      }
      const response = await fetch(image.currentSrc || image.src, { mode: 'cors', credentials: 'omit' });
      if (!response.ok) throw new Error(this.t.reportError);
      return this.readBlob(await response.blob());
    }

    inlineComputedStyles(source, clone) {
      const sourceElements = [source, ...source.querySelectorAll('*')];
      const cloneElements = [clone, ...clone.querySelectorAll('*')];
      sourceElements.forEach((element, index) => {
        const target = cloneElements[index];
        const computed = window.getComputedStyle(element);
        for (let propertyIndex = 0; propertyIndex < computed.length; propertyIndex += 1) {
          const property = computed[propertyIndex];
          target.style.setProperty(property, computed.getPropertyValue(property), computed.getPropertyPriority(property));
        }
      });
    }

    async capturePreviewScreenshot() {
      const source = !this.cardElements.preview.hidden
        ? this.cardElements.card
        : !this.cardElements.errorState.hidden
          ? this.cardElements.errorState
          : !this.cardElements.loading.hidden
            ? this.cardElements.loading
            : this.cardElements.empty;
      const rect = source.getBoundingClientRect();
      if (!rect.width || !rect.height) throw new Error(this.t.reportError);
      await document.fonts?.ready?.catch(() => {});
      const clone = source.cloneNode(true);
      this.inlineComputedStyles(source, clone);
      clone.style.margin = '0';
      clone.style.transform = 'none';
      const sourceImages = [...source.querySelectorAll('img')];
      const cloneImages = [...clone.querySelectorAll('img')];
      await Promise.all(sourceImages.map(async (image, index) => {
        cloneImages[index].src = await this.imageDataUrl(image);
        cloneImages[index].removeAttribute('srcset');
      }));

      const width = Math.ceil(rect.width);
      const height = Math.ceil(rect.height);
      const serialized = new XMLSerializer().serializeToString(clone);
      const svg = `<svg xmlns="http://www.w3.org/2000/svg" width="${width}" height="${height}" viewBox="0 0 ${width} ${height}"><foreignObject width="100%" height="100%"><div xmlns="http://www.w3.org/1999/xhtml" style="width:${width}px;height:${height}px;overflow:hidden">${serialized}</div></foreignObject></svg>`;
      const svgUrl = URL.createObjectURL(new Blob([svg], { type: 'image/svg+xml;charset=utf-8' }));
      try {
        const rendered = await new Promise((resolve, reject) => {
          const image = new Image();
          image.onload = () => resolve(image);
          image.onerror = () => reject(new Error(this.t.reportError));
          image.src = svgUrl;
        });
        let scale = Math.max(.55, Math.min(1.6, 1200 / width, 1800 / height));
        for (let attempt = 0; attempt < 5; attempt += 1) {
          const canvas = document.createElement('canvas');
          canvas.width = Math.round(width * scale);
          canvas.height = Math.round(height * scale);
          canvas.getContext('2d').drawImage(rendered, 0, 0, canvas.width, canvas.height);
          const screenshot = await new Promise((resolve) => canvas.toBlob(resolve, 'image/png'));
          if (!screenshot) throw new Error(this.t.reportError);
          if (screenshot.size <= 2_400_000) return screenshot;
          scale *= .78;
        }
        throw new Error(this.t.reportError);
      } finally {
        URL.revokeObjectURL(svgUrl);
      }
    }

    problemReportEndpoint() {
      const endpoint = new URL(this.apiEndpoint, window.location.href);
      endpoint.pathname = '/v1/card/problem';
      endpoint.search = '';
      endpoint.hash = '';
      return endpoint.href;
    }

    async reportProblem() {
      if (!this.apiEndpoint) return;
      const button = this.cardElements.reportButton;
      const status = this.cardElements.reportStatus;
      button.disabled = true;
      button.textContent = this.t.reportingProblem;
      status.textContent = '';
      try {
        const screenshot = await this.capturePreviewScreenshot();
        const page = new URL(window.location.href);
        page.search = '';
        page.hash = '';
        const payload = new FormData();
        const currentError = !this.cardElements.errorState.hidden ? this.lastGenerationError : null;
        const reference = currentError?.reviewReference || (currentError ? this.problemReportId : this.result?.draftId) || this.problemReportId;
        if (currentError?.reviewReference) payload.append('reviewReference', currentError.reviewReference);
        else if (currentError) payload.append('reportId', this.problemReportId);
        else if (this.result?.draftId) payload.append('draftId', this.result.draftId);
        else payload.append('reportId', this.problemReportId);
        payload.append('screenshot', screenshot, `problema-bizzymagic-${reference}.png`);
        payload.append('pageUrl', page.href);
        payload.append('locale', this.locale);
        payload.append('clientTime', new Date().toISOString());
        payload.append('clientError', currentError?.message || this.cardElements.errorMessage.textContent || this.error.textContent || '');
        payload.append('clientErrorCode', currentError?.code || 'none');
        payload.append('requestId', currentError?.requestId || '');
        const response = await fetch(this.problemReportEndpoint(), {
          method: 'POST',
          body: payload,
          headers: { Accept: 'application/json' },
        });
        if (response.status === 429) {
          const body = await response.json().catch(() => ({}));
          const seconds = Number(body.retryAfterSeconds) || this.parseRetryAfter(response.headers.get('Retry-After')) || 300;
          status.textContent = [this.t.reportDuplicate, this.retryTiming(seconds)].filter(Boolean).join(' ');
          button.textContent = this.t.reportProblem;
          this.startProblemReportCooldown(button, seconds);
          return;
        }
        if (!response.ok) throw new Error(this.t.reportError);
        status.textContent = this.t.reportSent;
        button.textContent = this.t.reportProblem;
        this.startProblemReportCooldown(button, 300);
      } catch {
        status.textContent = this.t.reportError;
        button.textContent = this.t.reportProblem;
        button.disabled = false;
      }
    }

    setPreviewState(state) {
      this.cardElements.empty.hidden = state !== 'empty';
      this.cardElements.loading.hidden = state !== 'loading';
      this.cardElements.errorState.hidden = state !== 'error';
      this.cardElements.preview.hidden = state !== 'preview';
    }

    renderManaCost(tokens) {
      const container = this.cardElements.mana;
      container.innerHTML = '';
      const fragment = document.createDocumentFragment();
      for (const rawToken of Array.isArray(tokens) ? tokens : []) {
        const token = String(rawToken);
        const symbol = document.createElement('span');
        symbol.className = 'bizzy-card-builder__mana-symbol';
        symbol.dataset.manaToken = token;
        if (MANA_ASSET_URLS[token]) {
          const image = document.createElement('img');
          image.src = MANA_ASSET_URLS[token];
          image.alt = token;
          image.decoding = 'async';
          symbol.append(image);
        } else {
          symbol.classList.add('bizzy-card-builder__mana-symbol--generic');
          symbol.textContent = token;
          symbol.setAttribute('aria-label', `${token} mana generico`);
        }
        fragment.append(symbol);
      }
      container.append(fragment);
    }

    applyColourIdentity(card) {
      const palettes = {
        W: { accent: '#d8c98a', deep: '#817447', soft: '#fbf3cf', rgb: '216 201 138', deepRgb: '129 116 71' },
        U: { accent: '#3da4d9', deep: '#153f66', soft: '#cceeff', rgb: '61 164 217', deepRgb: '21 63 102' },
        B: { accent: '#75677e', deep: '#201a26', soft: '#d4c8d8', rgb: '117 103 126', deepRgb: '32 26 38' },
        R: { accent: '#d85a45', deep: '#641f1e', soft: '#ffd0bc', rgb: '216 90 69', deepRgb: '100 31 30' },
        G: { accent: '#4aa66a', deep: '#164d33', soft: '#d0efd8', rgb: '74 166 106', deepRgb: '22 77 51' },
        C: { accent: '#a99d84', deep: '#3a352f', soft: '#ede6d7', rgb: '169 157 132', deepRgb: '58 53 47' },
      };
      const colors = Array.isArray(card.colorIdentity) && card.colorIdentity.length ? card.colorIdentity : ['C'];
      const first = palettes[colors[0]] || palettes.C;
      const second = palettes[colors[1]] || first;
      const third = palettes[colors[2]] || second;
      const element = this.cardElements.card;
      element.style.setProperty('--card-accent', first.accent);
      element.style.setProperty('--card-accent-deep', first.deep);
      element.style.setProperty('--card-accent-soft', first.soft);
      element.style.setProperty('--card-accent-secondary', second.accent);
      element.style.setProperty('--card-accent-secondary-deep', second.deep);
      element.style.setProperty('--card-accent-tertiary', third.accent);
      element.style.setProperty('--card-accent-tertiary-deep', third.deep);
      element.style.setProperty('--card-accent-rgb', first.rgb);
      element.style.setProperty('--card-accent-deep-rgb', first.deepRgb);
      element.style.setProperty('--card-secondary-rgb', second.rgb);
      element.style.setProperty('--card-secondary-deep-rgb', second.deepRgb);
      element.style.setProperty('--card-tertiary-rgb', third.rgb);
      element.style.setProperty('--card-tertiary-deep-rgb', third.deepRgb);
      element.dataset.colorIdentity = colors.join('');
    }

    validateRenderGeometry(card) {
      const failures = [];
      const { frame, art, title, type, rules, stats, footer, titlebar, lore } = this.cardElements;
      const mana = this.cardElements.mana.children;
      const artRect = art.getBoundingClientRect();
      const frameRect = frame.getBoundingClientRect();
      const panelRects = [titlebar, lore].map((element) => element.getBoundingClientRect());
      if (!frameRect.width || artRect.width / frameRect.width < .99 || artRect.height / frameRect.height < .99) failures.push('artwork is not full-bleed');
      if (Math.abs(artRect.left - frameRect.left) > 2 || Math.abs(artRect.top - frameRect.top) > 2) failures.push('artwork is not aligned with the full frame');
      if (panelRects.some((rect) => rect.left < frameRect.left - 2 || rect.right > frameRect.right + 2 || rect.top < frameRect.top - 2 || rect.bottom > frameRect.bottom + 2)) failures.push('a card panel leaves the frame');
      if (title.scrollWidth > title.clientWidth) failures.push('title overflows');
      if (type.scrollWidth > type.clientWidth) failures.push('type line overflows');
      if (rules.scrollHeight > rules.clientHeight) failures.push('rules text overflows');
      if (mana.length !== (Array.isArray(card.manaCost) ? card.manaCost.length : 0)) failures.push('mana symbols do not match the mana cost');
      if ((card.power == null || card.toughness == null) !== stats.hidden) failures.push('combat statistics visibility is incorrect');
      if (!stats.hidden) {
        const statsRect = stats.getBoundingClientRect();
        const footerRect = footer.getBoundingClientRect();
        if (statsRect.left < frameRect.left || statsRect.right > frameRect.right || statsRect.top < frameRect.top || statsRect.bottom > frameRect.bottom) failures.push('combat statistics leave the frame');
        if (statsRect.bottom > footerRect.top + 2) failures.push('combat statistics overlap the footer');
      }
      return failures;
    }

    renderPreview(result) {
      if (result?.qualityGate?.mode === 'enforced' && !this.hasExpectedPrintContract(result)) {
        throw new Error(this.t.contractUpgrade);
      }
      const card = result.card;
      const elements = this.cardElements;
      elements.printApproval.checked = false;
      elements.addCart.disabled = true;
      const preview = elements.preview;
      preview.dataset.renderPending = 'true';
      if (result.previewUrl && /^[0-9a-f]{64}$/.test(result.proofSha256 || '')) {
        elements.frame.hidden = true;
        elements.card.dataset.proof = 'canonical';
        let proof = elements.card.querySelector('[data-canonical-proof]');
        if (!proof) {
          proof = document.createElement('img');
          proof.className = 'bizzy-card-builder__canonical-proof';
          proof.dataset.canonicalProof = '';
          elements.card.append(proof);
        }
        proof.hidden = false;
        proof.crossOrigin = 'anonymous';
        proof.decoding = 'async';
        proof.fetchPriority = 'high';
        proof.alt = `${card.cardName} — prova canonica approvabile`;
        let proofLoadAttempt = 0;
        const loadProof = () => {
          const separator = result.previewUrl.includes('?') ? '&' : '?';
          proof.src = `${result.previewUrl}${separator}load_attempt=${proofLoadAttempt}`;
        };
        proof.onerror = () => {
          if (proofLoadAttempt < 3) {
            proofLoadAttempt += 1;
            window.setTimeout(loadProof, [0, 400, 1000, 2000][proofLoadAttempt]);
            return;
          }
          this.result = null;
          this.error.textContent = this.t.artworkError;
          this.cardElements.errorMessage.textContent = this.t.artworkError;
          this.setPreviewState('error');
        };
        proof.onload = () => {
          proof.onerror = null;
          proof.onload = null;
          if (proof.naturalWidth !== 815 || proof.naturalHeight !== 1111) {
            this.result = null;
            this.setPreviewState('empty');
            this.error.textContent = 'Render bloccato: la prova canonica non è 815 × 1111 px.';
            return;
          }
          delete preview.dataset.renderPending;
          this.syncAddToCartState();
        };
        loadProof();
        elements.note.textContent = this.t.liveNote;
        this.setPreviewState('preview');
        return;
      }

      elements.frame.hidden = false;
      delete elements.card.dataset.proof;
      const existingProof = elements.card.querySelector('[data-canonical-proof]');
      if (existingProof) existingProof.hidden = true;
      elements.title.textContent = card.cardName;
      elements.type.textContent = card.typeLine;
      elements.flavour.textContent = `“${card.flavourText}”`;
      const titleElement = elements.title;
      titleElement.style.fontSize = card.cardName.length > 38 ? '3.9cqi' : card.cardName.length > 28 ? '4.55cqi' : '5.35cqi';
      const typeElement = elements.type;
      typeElement.style.fontSize = card.typeLine.length > 52 ? '2.65cqi' : card.typeLine.length > 38 ? '3.05cqi' : '3.65cqi';
      this.renderManaCost(card.manaCost);
      this.applyColourIdentity(card);
      const stats = elements.stats;
      stats.hidden = card.power == null || card.toughness == null;
      elements.card.dataset.cardKind = stats.hidden ? 'noncreature' : 'creature';
      elements.statsText.textContent = stats.hidden ? '' : `${card.power}/${card.toughness}`;
      const abilities = Array.isArray(card.abilities) ? card.abilities.slice(0, 2) : [];
      elements.abilities.forEach((row, index) => {
        const ability = abilities[index];
        row.hidden = !ability;
        row.querySelector('[data-ability-text]').textContent = ability?.text || '';
      });
      const image = elements.image;
      image.crossOrigin = 'anonymous';
      image.decoding = 'async';
      image.fetchPriority = 'high';
      image.alt = card.cardName;
      image.onerror = () => {
        this.result = null;
        this.setPreviewState('empty');
        this.error.textContent = this.t.artworkError;
      };
      image.onload = () => {
        image.onerror = null;
        image.onload = null;
        requestAnimationFrame(() => {
          const failures = this.validateRenderGeometry(card);
          if (failures.length) {
            this.result = null;
            this.setPreviewState('empty');
            this.error.textContent = `Render bloccato: ${failures.join('; ')}.`;
            return;
          }
          delete preview.dataset.renderPending;
          this.syncAddToCartState();
        });
      };
      image.src = result.artUrl;
      elements.note.textContent = result.qualityGate?.mode === 'draft-bypass'
        ? this.t.rawQaNote
        : (this.demoMode ? this.t.demoNote : this.t.liveNote);
      this.setPreviewState('preview');
    }

    edit() {
      this.setPreviewState('empty');
      this.showStep(0);
      this.root.scrollIntoView({ behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'start' });
    }

    hasValidCartVariant() {
      return Number.isSafeInteger(this.variantId)
        && this.variantId > 0
        && this.packSize === 10
        && this.priceCents === 999;
    }

    hasExpectedPrintContract(result = this.result) {
      const contract = result?.purchaseContract;
      return contract?.version === PURCHASE_CONTRACT_VERSION
        && contract?.printSpecVersion === PRINT_SPEC_VERSION
        && contract?.assetSetId === PRINT_ASSET_SET_ID
        && contract?.backSha256 === PRINT_BACK_ASSET_SHA256;
    }

    hasValidPurchaseContract(result = this.result) {
      const contract = result?.purchaseContract;
      return result?.qualityGate?.decision === 'PASS'
        && result?.qualityGate?.mode === 'enforced'
        && this.hasExpectedPrintContract(result)
        && contract?.draftId === result?.draftId
        && contract?.variantId === String(this.variantId)
        && contract?.packSize === this.packSize
        && contract?.priceCents === this.priceCents
        && /^[0-9a-f]{64}$/.test(contract?.proofSha256 || '')
        && contract.proofSha256 === result?.proofSha256
        && Number.isFinite(contract?.expiresAt)
        && contract.expiresAt > Date.now()
        && /^[A-Za-z0-9_-]{43}$/.test(contract?.authorization || '');
    }

    syncAddToCartState() {
      this.cardElements.addCart.disabled = this.cardElements.preview.dataset.renderPending === 'true'
        || !this.cartEnabled
        || !this.hasValidCartVariant()
        || !this.hasValidPurchaseContract()
        || !this.cardElements.printApproval.checked;
    }

    async addToCart() {
      if (!this.cartEnabled || !this.hasValidCartVariant() || !this.hasValidPurchaseContract() || !this.cardElements.printApproval.checked) return;
      const button = this.root.querySelector('[data-add-cart]');
      button.disabled = true;
      button.textContent = this.t.adding;
      try {
        const approvedAt = new Date().toISOString();
        const response = await fetch(this.root.dataset.cartAddUrl, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: [{
            id: this.variantId, quantity: 1,
            properties: {
              '_BizzyMagic draft ID': this.result.draftId,
              '_BizzyMagic preview': this.result.previewUrl,
              '_BizzyMagic authorization': this.result.purchaseContract.authorization,
              '_BizzyMagic contract': this.result.purchaseContract.version,
              '_BizzyMagic contract expiry': String(this.result.purchaseContract.expiresAt),
              '_BizzyMagic print spec': this.result.purchaseContract.printSpecVersion,
              '_BizzyMagic proof SHA-256': this.result.purchaseContract.proofSha256,
              '_BizzyMagic asset set': this.result.purchaseContract.assetSetId,
              '_BizzyMagic back SHA-256': this.result.purchaseContract.backSha256,
              '_BizzyMagic print approval': 'approved',
              '_BizzyMagic print approval at': approvedAt,
              'Nome carta': this.result.card.cardName,
              'Tipo carta': this.result.card.typeLine,
              'Colori carta': this.formatColourIdentity((this.result.card.selectedColorIdentity || (this.result.card.colorIdentity?.length ? this.result.card.colorIdentity : ['C'])).join(',')),
              'Formato': this.t.bundle,
              'Carte nel set': String(this.packSize),
            },
          }] }),
        });
        if (!response.ok) throw new Error(this.t.cartError);
        window.location.assign(this.root.dataset.cartUrl);
      } catch (error) {
        this.syncAddToCartState();
        button.textContent = this.t.add;
        this.error.textContent = error?.message || this.t.cartError;
      }
    }
  }

  document.querySelectorAll(BUILDERS).forEach((root) => new BizzyMagicCardBuilder(root));
})();
